import { render, staticRenderFns } from "./ExpensePivotList.vue?vue&type=template&id=d87002aa"
import script from "./ExpensePivotList.vue?vue&type=script&lang=js"
export * from "./ExpensePivotList.vue?vue&type=script&lang=js"
import style0 from "./ExpensePivotList.vue?vue&type=style&index=0&id=d87002aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports